var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-pbi',{attrs:{"report-id":"9ad72920-33cf-4e0b-ac59-f734fdd5ac76","group-id":"5de7d4a7-b0d1-41a8-a978-693e831cfdcd"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }